import React from 'react';
import { Control, FieldErrors, UseFormSetValue } from 'react-hook-form';

import SelectApi from '../../common/SelectApi';
import { WidgetDestPointNetoProps } from '../Dashboard.types';

interface DestPointNetoFiltersProps {
 control: Control<WidgetDestPointNetoProps>;
 setValue: UseFormSetValue<WidgetDestPointNetoProps>;
 errors: FieldErrors<WidgetDestPointNetoProps>;
}

const DestPointNetoFilters: React.FC<DestPointNetoFiltersProps> = ({
 control,
 setValue,
 errors,
}) => {
 const productFilter = JSON.stringify({ fields: 'Id,Name' });

 const destPointFilter = JSON.stringify({ fields: 'Id,Name' });
 return (
  <>
   <SelectApi<WidgetDestPointNetoProps>
    name="toDestPoint"
    url="/api/DestPoint/v1/"
    filter={destPointFilter}
    label="Paskirties taškai (ToDestPoint)"
    isEditable
    operator="contains"
    control={control}
    setValue={setValue}
    multiple
   />
   <SelectApi<WidgetDestPointNetoProps>
    name="products"
    url="/api/Products/v2/"
    filter={productFilter}
    label="Products"
    isEditable
    operator="contains"
    control={control}
    setValue={setValue}
   />
  </>
 );
};

export default DestPointNetoFilters;
